import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID } from '@angular/core';

import { AuthTokenInterceptor, UnauthorizedInterceptor } from '../authentication';
import { HeaderVersionInterceptor, SensitiveRequestsInterceptor } from '../interceptors';
import {
  ApiService,
  AuthConfigReaderService,
  ConfigAppConfigProvider,
  ConfigEnvironmentProvider,
  CryptoProvider,
  ResourceProvider,
  ServerSettingsProvider,
  TileMenuService,
  TitleMachineService,
  TutorialService,
} from '../providers';

export const AppMobileConfig: ApplicationConfig = {
  providers: [
    ApiService,
    AuthConfigReaderService,
    ResourceProvider,
    CryptoProvider,
    TileMenuService,
    TitleMachineService,
    TutorialService,
    {
      provide: 'appConfigs',
      useClass: ConfigEnvironmentProvider,
      multi: true,
    },
    {
      provide: 'appConfigs',
      useClass: ConfigAppConfigProvider,
      multi: true,
    },
    {
      provide: 'appConfigs',
      useClass: ServerSettingsProvider,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderVersionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SensitiveRequestsInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'de',
    },
  ],
};
